<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>调薪初审单说明:</h5><br>
				<span>1、单号构成规则:201201+TX+4位顺序号。系统生成,添加无效</span><br>
				<span>2、业务说明:调薪申请=>领导审核=>老板终审=>通过后修改对应工资数据!</span><br>
				<span class="red">3、说明:新角色不选则默认不变。</span><br>
				<span>4、查询关键字:单号、部门、申请人。</span><br>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">

		</pre-base>
	</div>
</template>

<script>
	
	export default {
		components: {
			"pre-base": () => import("../auto/old_view_v1.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',
				// 下拉菜单
				// list_fee: [],
				// sel_fee: {},
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '调薪初审',
					"control": "salaryhistory",
					"isTwo": "0",
					"isTwoDetail": "0",
					"isFileMain": "1",
					"sel_action": 'exp_kq_s_history',
					"upd_action": 'exp15_kq_s_history',
					"d_sel_action": '',
					"d_upd_action": '',
					"file_action": 's_history',
					"p1": 'kq',
					"p2": 's_history',
					"p3": '',
					"parm_sel": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "select",
							"class": "long1",
							"sel_action": '_base_dep',
							"sel_name": "",
							"sel": "2"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "select",
							"class": "long1",
							"sel_action": '_base_roleuser',
							"sel_name": "",
							"sel": "3"
						}
					],
					"parm": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"x": "1",
							"r": "1"
						},
						{
							"name": "部门",
							"val": "",
							"key": "d_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "申请人",
							"val": "",
							"key": "u2_name",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "当前角色",
							"val": "",
							"key": "r_name_old",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "当前薪水",
							"val": "",
							"key": "salay_old",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "调薪涨幅",
							"val": "",
							"key": "salay_up",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "1",
							"r": "1"
						},
						{
							"name": "调薪说明",
							"val": "",
							"key": "salay_up_note",
							"type": "textarea",
							"class": "long5",
							"note": "请输入调薪说明,最多不超过200个汉字",
							"p": "0",
							"x": "2",
							"r": "1",
							"w": "0"
						},
						{
							"name": "基本绩效",
							"val": "",
							"key": "s_base",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "岗位工资",
							"val": "",
							"key": "s_role",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "交通补贴",
							"val": "",
							"key": "s_butie",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "餐补",
							"val": "",
							"key": "can_butie",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "话补",
							"val": "",
							"key": "hua_butie",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "社保补贴",
							"val": "",
							"key": "shebao_butie",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "3",
							"r": "1",
							"w": "0"
						},
						{
							"name": "新基本工资",
							"val": "",
							"key": "new_base",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4",
							"r": "0"
						},
						{
							"name": "新岗位绩效",
							"val": "",
							"key": "new_role",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4",
							"r": "0"
						},
						{
							"name": "新交通补贴",
							"val": "",
							"key": "new_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4",
							"r": "0"
						},
						{
							"name": "新餐补",
							"val": "",
							"key": "new_can_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4",
							"r": "0"
						},
						{
							"name": "新话补",
							"val": "",
							"key": "new_hua_butie",
							"type": "number",
							"class": "long1",
							"w": "1",
							"p": "1",
							"x": "4",
							"r": "0"
						},
						{
							"name": "新社保补贴",
							"val": "",
							"key": "new_shebao_butie",
							"type": "number",
							"class": "long1",
							"p": "1",
							"x": "4",
							"r": "0",
							"w": "0"
						},
						{
							"name": "新角色",
							"val": "",
							"key": "r_name_new",
							"type": "select",
							"class": "long1",
							"sel_action": '_base_role',
							"sel_name": "",
							"p": "1",
							"x": "5",
							"r": "0",
							"w": "0"
						},
						{
							"name": "新薪水",
							"val": "",
							"key": "salay_new",
							"type": "text",
							"class": "long1",
							"p": "0",
							"x": "5",
							"r": "1",
							"w": "0"
						},
						{
							"name": "初审说明",
							"val": "",
							"key": "note",
							"type": "textareaedit",
							"class": "long5",
							"p": "1",
							"x": "6",
							"r": "0",
							"w": "1"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "申请单"
						},
						{
							"name": "部门"
						},
						{
							"name": "申请人"
						},
						{
							"name": "角色"
						},
						{
							"name": "状态"
						},
						{
							"name": "当前薪水"
						},
						{
							"name": "调薪涨幅"
						},
						{
							"name": "调薪说明"
						},
						{
							"name": "基本工资"
						},
						{
							"name": "岗位工资"
						},
						{
							"name": "交通补贴"
						},
						{
							"name": "餐补"
						},
						{
							"name": "话补"
						},
						{
							"name": "社保补贴"
						},
						{
							"name": "新角色"
						},
						{
							"name": "新基本工资"
						},
						{
							"name": "新岗位工资"
						},
						{
							"name": "新交通补贴"
						},
						{
							"name": "新餐补"
						},
						{
							"name": "新话补"
						},
						{
							"name": "新社保补贴"
						},
						{
							"name": "调薪初审说明"
						},
						{
							"name": "调薪后薪水"
						},
						{
							"name": "录入人"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": []
				});

			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				// console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}





		}
	};
</script>
<style>
</style>